module.exports = __webpack_public_path__ + "static/media/supportCarousal0a.4174425d.svg";